import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";

@inject("store")
@observer
export default class CategoryProducts extends React.Component {
    @observable productIndex = 0;

    // model props
    constructor(props) {
        super(props);

        this.focusProduct = this.focusProduct.bind(this);
        this.openProductDialog = this.openProductDialog.bind(this);
        //this.state = {productIndex: 0 };
    }

    openProductDialog(e, product, i) {
        e.stopPropagation();
        e.preventDefault();
        this.productIndex = i;
        this.props.store.navigation.openProductDialog(product);
    }


    focusProduct(e, i, product) {
        e.preventDefault();
    }


    render() {
        //console.debug("CategoryProduct - RENDER", this.props);
        // Handle single, or grouped products
        const navigation = this.props.store.navigation;

        if (this.props.product == null) {
            return null;
        }


        const products = !Array.isArray(this.props.product) ? [this.props.product] : this.props.product;
        const product = products[this.productIndex];

        if (product) {
            return (
                <div className="category-product-container">
                    <div className="product-card mb-30" onClick={
                        (e) => {
                            this.openProductDialog(e, product, this.productIndex);
                        }} style={{ cursor: "pointer" }}>
                        <div className="product-card-thumb">
                            <a className="product-card-link" onClick={
                                (e) => {
                                    this.openProductDialog(e, product, this.productIndex + 1);
                                }} style={{ cursor: "pointer" }}></a>

                            {!product.PrimaryImageUrl || product.PrimaryImageUrl === ""
                                ? <img src="/dist/img/no_image.jpg" />
                                : <img src={product.PrimaryImageUrl + "?width=263"} alt={product.Name} />
                            }


                        </div>
                        {products.length === 1 ? <div style={{ height: "40px" }}></div> : <div>
                            {products.map((p, i) =>
                            (<a key={p.ProductId}
                                href=""
                                onClick={
                                    (e) => {
                                        this.openProductDialog(e, p, i + 1);
                                    }}>
                                <img
                                    src={(p.PrimaryImageUrl ? p.PrimaryImageUrl : "/dist/img/no_image.jpg") + "?width=40"}
                                    title={p.Name} width={40} />
                            </a>))}

                        </div>}
                        <div className="product-card-title-container">
                            <div className="product-card-title">
                                {product.Name}
                            </div>
                            <div className="product-card-sku">{product.Sku}</div>
                        </div>
                        <div className="product-card-prices">
                            {!navigation.CustomerRoleIsReadOnly ?
                                <div className="product-card-price">{product.PriceFormatted}</div> : null}
                            {product.RetailPriceFormatted && product.RetailPriceFormatted.length > 0 ? <div
                                className="product-card-price-retail">Retail: {product.RetailPriceFormatted}</div> : null}
                        </div>
                        {true == false && !navigation.CustomerRoleIsReadOnly ?
                            <div className="product-card-actions">
                                <button className="btn btn-primary btn-sm" data-toast="" data-toast-type="success"
                                    data-toast-position="topRight" data-toast-icon="material-icons check"
                                    data-toast-title="Product" data-toast-message="successfuly added to cart!"
                                    onClick={(e) => {
                                        this.openProductDialog(e, product, this.productIndex);
                                    }}>Add
                                </button>
                            </div> : null}

                    </div>


                </div>
            )
        } else
            return null;
    }
}